// The owner's preview of the draft gate's colours before go-live (stage 3 /
// C, #332; server lib/gateHoldout.js): /drafts' ⋮ "הצג צבעי בדיקה" switches
// it on or off for this login. The server decides who may — only a login on
// GATE_PREVIEW_USERS while GATE_HOLDOUT_SALT is unset — and ignores the switch
// for anyone else, so this file only remembers the choice and says it.
//
// Module memory first (both screens read it in this tab), localStorage to
// carry it to the next visit, best effort — the same two layers as
// utils/draftQueueOrder.js. Off by default.

const keyFor = (uid) => `peak.gatePreview.${uid ?? 'anon'}`;
const chosenThisTab = new Map();

export function readGatePreview(uid) {
  const key = keyFor(uid);
  if (chosenThisTab.has(key)) return chosenThisTab.get(key);
  try {
    return window.localStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}

export function writeGatePreview(uid, on) {
  const key = keyFor(uid);
  chosenThisTab.set(key, !!on);
  try {
    window.localStorage.setItem(key, on ? '1' : '0');
  } catch {
    // Not remembered for the next visit; this tab still uses the choice.
  }
}

/** Tests only. */
export const forgetGatePreviewForTests = () => { chosenThisTab.clear(); };
